import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// Sets up Vue for the vue-bootstrap library.
export default function (Vue) {
  Vue.use(BootstrapVue)
}



// WEBPACK FOOTER //
// ./src/core/setup-bootstrap.js